<template>
  <div class="item-container" @click="navigate">
    <img
      :src="item.picture"
      class="w-full"
      :alt="item.label"
      loading="lazy"
      decoding="async"
    />
    <span class="text-lg">{{ item.label }}</span>
    <b>{{ item.price }}€</b>
  </div>
</template>

<script setup>
const props = defineProps(['item']);
const router = useRouter();
const localePath = useLocalePath();
function navigate() {
  router.push({ path: localePath(`/shop/${props.item.slug}`) });
}
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";
.item-container {
  @apply w-full sm:w-1/3 xl:w-1/5 m-2 cursor-pointer flex flex-col items-center hover:shadow-lg;
}
</style>
